require("./wdh-legacy/search/js/corporate-template/component-search.js");